var _dec, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { layout as templateLayout } from '@ember-decorators/component';
import layout from '../templates/components/fly-select-grouped';
import FlySelectComponent from './fly-select';
import { isNone } from '@ember/utils';

/**
  The fly-select-grouped component extends the fly-select component and adds the
  ability to group options together. All of the props are the same except for
  `items`.

  fly-select-grouped takes a `groups` prop that replaces the `items` prop from
  fly-select. See the `groups` argument below for the expected schema.

  ```hbs
  <FlySelectGrouped
    \@groups={{options}}
    \@selectedValue={{selectedValue}} />
  ```

  @class FlySelectGrouped
  @public
 */
let FlySelectGrouped = (_dec = templateLayout(layout), _dec(_class = class FlySelectGrouped extends FlySelectComponent {
  constructor(...args) {
    super(...args);
    /**
      The grouped array of items to be rendered in the `select` element.
       ```js
      const groups = [
        {
          label: "Group 1",
          items: [{ value: "a", label: "Option a" }, { value: "b", label: "Option b" }]
        },
        {
          label: "Group 2",
          items: [{ value: "c", label: "Option c" }]
        }
      ]
      ```
       @argument groups
      @type array
     */
    _defineProperty(this, "groups", null);
  }
  _selectedValueExists() {
    let {
      selectedValue,
      groups
    } = this.getProperties('selectedValue', 'groups');
    if (isNone(groups) || isNone(selectedValue)) {
      return false;
    }
    return groups.some(group => group.items.some(item => item.value === selectedValue));
  }
}) || _class);
export { FlySelectGrouped as default };